/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancelsubscription1Inputs */

const en_cancelsubscription1 = /** @type {(inputs: Cancelsubscription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel Subscription`)
};

const de_cancelsubscription1 = /** @type {(inputs: Cancelsubscription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement kündigen`)
};

/**
* | output |
* | --- |
* | "Cancel Subscription" |
*
* @param {Cancelsubscription1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cancelsubscription1 = /** @type {((inputs?: Cancelsubscription1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancelsubscription1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cancelsubscription1(inputs)
	return de_cancelsubscription1(inputs)
});
export { cancelsubscription1 as "cancelSubscription" }